import React from 'react'
import Login from '../components/Login'
import Signup from '../components/Signup'


export default function Account() {
  return (
    <div>Account
      <Signup />
      <br />
      <Login />
    </div>
  )
}
